import createUpload from '@ai/mss-upload-js'
import { owlAddJsInfo } from '@RootCommon/utils/owl'
import { getLoginShopid, getWebId } from '@RootCommon/utils'
import { getHornConfig } from '@RootCommon/utils/horn'

export default async function uploadLogs (day?: number | string) {
  try {
    const uuid = getWebId()
    const shopId = getLoginShopid()
    const fileName = uuid ? `${shopId}_${uuid.slice(-6)}` : shopId
    const buffer = await window.electronAPI?.getAppLogs?.(day || 1)
    const blob = new Blob([buffer], { type: 'application/zip' })
    const file = new File([blob], `omlog/${fileName}.zip`, { type: 'application/zip' })
    const isTest = ['newtest', 'test'].includes(process.env.AWP_DEPLOY_ENV)

    createUpload({
      file,
      signatureUrl: '/api/operate/device/getNormalUploadSign',
      s3_host: isTest ? undefined : 's3-ap-hongkong.mykeeta.com',
      bucket: 'sailorfempc',
      prefix_type: 's3_style',
      key: file.name,
      isTest,
      onSuccess () {},
      onError (errorMsg) {
        owlAddJsInfo('本地日志上传失败', { errorMsg })
      },
    }, 1).upload()
  } catch (e) {
    owlAddJsInfo('本地日志获取或上传失败', {
      errorMsg: JSON.stringify(e, Object.getOwnPropertyNames(e), 2),
    })
  }

}

export async function autoUploadLogs () {
  const hornConfig = await getHornConfig()
  const shopIdConfig = hornConfig.autoUploadLog || []
  const currShopId = getLoginShopid()
  const matchShopId = shopIdConfig.find(item => String(item.shopId) === String(currShopId))

  if (matchShopId) {
    // 延时上传，不阻塞主线程
    setTimeout(() => {
      uploadLogs(matchShopId.day)
    }, 10000)
  }

}

// @ts-ignore
window.omLogUpload = uploadLogs